<template>
  <div>
    <div class="design-page-header">
      <a-row>
        <a-col :span="7" style="display: flex; height: 56px; align-items: center">
          <a-space>
            <a-button shape="circle" icon="left" style="margin-left: 12px" @click="onBack" />
            <span class="workflow-name">{{ basicForm.name || '新建流程' }}</span>
          </a-space>
        </a-col>
        <a-col :span="10">
          <a-steps v-model="current" type="navigation" size="small" style="margin-top: 8px">
            <a-step value="0" title="基础信息" />
            <a-step v-if="false" title="审批表单" disabled />
            <a-step title="审批流程" />
          </a-steps>
        </a-col>
        <a-col :span="7" style="display: flex; justify-content: end; height: 56px; align-items: center">
          <a-button type="primary" style="margin-right: 12px" :loading="loading" @click="onSave">保存</a-button>
        </a-col>
      </a-row>
    </div>
    <a-spin :spinning="spinning">
      <basic-info-form v-show="current === 0" v-model="basicForm" />
      <process-designer v-show="current === 1" v-model="processForm" />
    </a-spin>
  </div>
</template>

<script>
import { workflowTemplateDetail, workflowTemplateModify, workflowTemplateCreate } from '@/api/project/workflow';

import BasicInfoForm from '@/pages/system/workflow/components/BasicInfoForm';
import ProcessDesigner from '@/pages/system/workflow/components/ProcessDesigner';

class Node {
  constructor(id, name, children) {
    this.id = id;
    this.name = name;
    this.children = children;
  }
}

export default {
  components: { BasicInfoForm, ProcessDesigner },
  data() {
    return {
      current: 0,
      loading: false,
      spinning: false,
      basicForm: {
        name: null,
        description: null,
        release_type_options: []
      },
      processForm: [],
      dataSource: {},
      id: parseInt(this.$route.query.id) || null
    };
  },
  mounted() {
    if (this.id !== null) {
      this.getWorkflowTemplateDetail();
    } else {
      this.$store.commit('setDesign', {
        process: {
          id: 'root',
          desc: '任何人',
          name: '发起人',
          type: 'ROOT',
          props: { formPerms: [], assignedUser: [] },
          children: {},
          parentId: null
        }
      });
    }
  },
  methods: {
    /**
     * 获取流程模板详情
     */
    getWorkflowTemplateDetail() {
      this.spinning = true;
      workflowTemplateDetail({ id: this.id }).then(res => {
        this.spinning = false;
        this.dataSource = res.data;
        this.basicForm = {
          name: res.data.name,
          description: res.data.description,
          release_type_options: res.data.release_type_options
        };
        this.stepsForm = res.data.steps;

        const process = this.createTree(res.data.steps);
        this.$store.commit('setDesign', { process: process });
      });
    },

    createTree(data) {
      const head = {
        id: 'node_' + data[0].id,
        node_id: data[0].id,
        name: data[0].name,
        desc: data[0].description,
        type: 'ROOT',
        props: {
          formPerms: [],
          assignedUser: [],
          operation_roles: data[0].operation_roles,
          move_mode: data[0].move_mode,
          back_options: data[0].back_options.map(item => 'node_' + item)
        },
        children: {},
        parentId: null
      };

      let currentNode = head;

      for (let i = 1; i < data.length; i++) {
        const { id, name, description, operation_roles, back_options, move_mode } = data[i];
        const newNode = {
          id: 'node_' + id,
          node_id: id,
          name: name,
          desc: description,
          type: 'APPROVAL',
          props: {
            formPerms: [],
            assignedUser: [],
            operation_roles: operation_roles,
            move_mode: move_mode,
            back_options: back_options.map(item => 'node_' + item)
          },
          children: {},
          parentId: 'node_' + data[i - 1].id
        };
        currentNode.children = newNode;
        currentNode = newNode;
      }

      return head;
    },

    treeToList(tree) {
      const list = [];
      function dfs(node) {
        if (Object.keys(node).length === 0) {
          return;
        }
        list.push({
          name: node.name,
          id: node.node_id || 0,
          node_id: node.id,
          description: node.description,
          move_mode: node.props && node.props.move_mode ? node.props.move_mode : 1,
          operation_roles: node.props && node.props.operation_roles ? node.props.operation_roles : [],
          next_options: node.children ? [node.children.id] : [],
          back_options: node.props && node.props.back_options ? node.props.back_options : []
        });
        if (node.children && Object.keys(node.children).length !== 0) {
          dfs(node.children);
        }
      }
      dfs(tree);
      return list;
    },

    /**
     * 点击保存
     */
    onSave() {
      this.loading = true;
      const steps = this.treeToList(this.$store.state.design.process);
      if (this.id !== null) {
        workflowTemplateModify({
          id: this.id,
          name: this.basicForm.name,
          description: this.basicForm.description,
          template_type: this.dataSource.template_type,
          release_type_options: this.basicForm.release_type_options,
          workflow_type_options: this.dataSource.workflow_type_options,
          steps: steps
        })
          .then(() => {
            this.loading = false;
            this.$message.success('保存成功');
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        workflowTemplateCreate({
          name: this.basicForm.name,
          description: this.basicForm.description,
          template_type: this.dataSource.template_type,
          release_type_options: this.basicForm.release_type_options,
          workflow_type_options: this.dataSource.workflow_type_options,
          steps: steps
        })
          .then(() => {
            this.loading = false;
            this.$message.success('保存成功');
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    /**
     * 点击返回
     */
    onBack() {
      this.$router.push({
        name: 'pages:system:workflow'
      });
    }
  }
};
</script>

<style>
.design-page-header {
  background-color: #fff;
  height: 56px;
  margin-bottom: 12px;
}
.workflow-name {
  width: 300px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis; /* 文本溢出显示省略号 */
  white-space: nowrap; /* 文本不会换行 */
  vertical-align: bottom; /* 处理inline-block导致的元素上浮问题 */
}
</style>
